import ArrayModal from "./ArrayInput";

export default ArrayModal;
